import styles from './Jeemocktest.module.css'
import OnlineMode from '../../assets/offline_mode_icon.svg'
import TestPrepIcon from '../../assets/jee_test_prep_icon.svg'

const JeeTestCriteria = () => {
    return (
        <div className='container'>
            <div className={`${styles.jeetestwrapper}`}>
                <div className={`${styles.jeetcheading}`}>
                    <h2>Test details</h2>
                </div>
                <div className={`${styles.jeewappertest}`}>
                    <div className={`${styles.jee_test_box} ${styles.jee_blue_box}`}>
                        <img src={OnlineMode} alt="online mode"/>
                        <h3>Online Mode</h3>
                        <p>Ensuring fair and secure assessments from anywhere</p>
                    </div>
                    <div className={`${styles.jee_test_box} ${styles.jee_pink_box}`}>
                        <img src={TestPrepIcon} alt="test prep"/>
                        <h3>Test preparation</h3>
                        <p>Syllabus as per NTA & new JEE (Main) pattern</p>
                    </div>
                    <div className={`${styles.jee_test_box} ${styles.jee_darkpink_box}`}>
                        <img src="https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/time-icon2.svg" alt="calendar" />
                        <h3>Exam dates & Duration</h3>
                        <p>Dec 2025 : <strong>28th </strong>| Jan 2026 : <strong>4th & 11th</strong></p>
                        <p>Duration : <strong>3 hours</strong></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JeeTestCriteria